<template>
    <div class="favorites" @click="toggleShare = false">
        <h1>Favorites</h1>
        <p>
            Save images to this page by clicking the "star" button to create a
            cusom list of art work, then share (email, message or post) or save
            as pdf (for print or personal use)
        </p>
        <div class="filters">
            <span class="material-icons">sort</span>
            <h3>Sort By</h3>
            <div class="select-wrap">
                <select v-model="searches.sortBy">
                    <option value="">Default</option>
                    <option value="size_asc">size ⇧</option>
                    <option value="size_desc">size ⇩</option>
                    <option value="price_asc">price ⇧</option>
                    <option value="price_desc">price ⇩</option>
                    <option value="artist">artist</option>
                    <option value="recent">most recent</option>
                </select>
            </div>
            <a class="button" @click="clearFavorites">
                Clear all favorites <span class="material-icons">clear</span>
            </a>
            <div class="button-menu" :class="{active:toggleShare}">
                 <a class="button" @click.stop="toggleShare = !toggleShare">
                    Share or Save as PDF
                    <span class="material-icons">share</span>
                </a>
                <div class="links">
                    <a class="button" @click.prevent.stop="copyLink" :href="permaLink">
                        Copy link
                        <span class="material-icons">{{ copyLinkIcon }}</span>
                    </a>
                    <router-link class="button" :to="{
                        name: 'contact',
                        query: { artwork: favorites.join(',') },
                    }">
                        Inquire about these works
                        <span class="material-icons">question_mark</span>
                    </router-link>
                    <a class="button" @click.stop="savePdf" v-if="!pdfLoading">
                        Save as PDF
                        <span class="material-icons">picture_as_pdf</span>
                    </a>
                    <a class="button" disabled v-else>
                        {{ pdfProgress }}
                        <span class="material-icons mdi-spin">loop</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="artworks" v-if="sortedArtworks.length">
            <transition-group name="favorite">
                <Artwork
                    v-for="artwork in sortedArtworks"
                    :key="artwork.nid"
                    :artwork="artwork"
                    :show-artist="true"
                    @click.capture.prevent=""
                    @click="selectedArtwork = artwork"
                />
            </transition-group>
        </div>
        <div class="no-results" v-else>No favorites chosen</div>
        <transition name="modal">
            <modal v-if="selectedArtwork" @close="selectedArtwork = null">
                <template v-slot:body>
                    <Artwork
                        :key="selectedArtwork.nid"
                        :artwork="selectedArtwork"
                        :teaser="false"
                        :show-artist="true"
                    />
                    <a
                        v-if="previousArtwork"
                        @click="selectedArtwork = previousArtwork"
                        class="prev"
                        >Prev</a
                    >
                    <a
                        v-if="nextArtwork"
                        @click="selectedArtwork = nextArtwork"
                        class="next"
                        >Next</a
                    >
                    <div style="display: none" class="preloader">
                        <img
                            :src="previousArtwork.fullImage"
                            v-if="previousArtwork"
                        />
                        <img :src="nextArtwork.fullImage" v-if="nextArtwork" />
                    </div>
                </template>
            </modal>
        </transition>
    </div>
</template>

<script>
import ArtworkHelper from "@/mixins/PageHelper.js";
import { Favorites } from "@/state.js";
import ArtworkPdf from "@/helpers/pdf.js";

export default {
    name: "Search",
    mixins: [ArtworkHelper],
    created(){
        const vm = this;
        if (vm.$route.query.fav) {
            // var savedFaves = [...vm.favorites];
            // if (savedFaves.length) {
            //     vm.$router.replace({name: 'favorites', query: {v: vm.favorites.join('|')}})
            // }
            vm.favorites = vm.decodeFavorites(vm.$route.query.fav);
            //vm.favorites = vm.$route.query.fav.split(',').map(n => parseInt(n).toString());
            // vm.$router.push({name: 'favorites', query: {v: vm.favorites.join('|')}})
            vm.$router.replace({name: 'favorites'})
            // router.replace(location
            //
            //console.log(vm.favorites);
        }
    },
    data() {
        return {
            favorites: Favorites,
            selectedArtwork: null,
            pdfLoading: false,
            pdfProgress: "",
            toggleShare: false,
            copyLinkIcon: "content_copy"
        };
    },
    computed: {
        documentTitle() {
            return "Favorites | " + this.documentTitleBase;
        },
        filteredArtworks() {
            const vm = this;
            var artworks = vm.allArtworks;
            artworks = artworks.filter((artwork) =>
                vm.favorites.includes(artwork.nid)
            );
            return artworks;
        },
        permaLink() {
            const vm = this;
            return vm.favoritesPermaLink(vm.favorites);
        },
    },
    methods: {
        copyLink() {
            const vm = this;
            navigator.clipboard.writeText(vm.permaLink);
            vm.copyLinkIcon = 'done';
            setTimeout(() => vm.copyLinkIcon = 'content_copy', 2000);
        },
        clearFavorites() {
            const vm = this;
            if (
                window.confirm(
                    "Are you sure you want to clear all your favorites?"
                )
            ) {
                vm.favorites = [];
            }
        },
        async savePdf() {
            const vm = this;
            vm.pdfLoading = true;
            const logo = require("@/assets/logo.png");
            //console.log('todo save pdf', logo, ArtworkPdf, vm);
            vm.pdfProgress = "Building PDF...";

            await ArtworkPdf(
                vm.filteredArtworks,
                logo,
                (msg, numDone, numTotal) => {
                    // console.log('ArtworkPdf', msg, numDone, numTotal);
                    var pct = Number.parseInt((100 * numDone) / numTotal);
                    if (pct == 100) pct = 99;
                    vm.pdfProgress = "Building PDF... " + pct + "% done";
                }
            );

            vm.pdfLoading = false;
        },
    },
};
</script>

<style lang="scss">
</style>
